var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.54 6.54a.65.65 0 0 1 .92 0l8.89 8.89V7a.65.65 0 1 1 1.3 0v10a.65.65 0 0 1-.65.65H7a.65.65 0 1 1 0-1.3h8.43L6.54 7.46a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjU0MDM4IDYuNTQwMzlDNi43OTQyMiA2LjI4NjU1IDcuMjA1NzggNi4yODY1NSA3LjQ1OTYyIDYuNTQwMzlMMTYuMzUgMTUuNDMwOEwxNi4zNSA3LjAwMDAxQzE2LjM1IDYuNjQxMDIgMTYuNjQxIDYuMzUwMDEgMTcgNi4zNTAwMUMxNy4zNTkgNi4zNTAwMSAxNy42NSA2LjY0MTAyIDE3LjY1IDcuMDAwMDFMMTcuNjUgMTdDMTcuNjUgMTcuMzU5IDE3LjM1OSAxNy42NSAxNyAxNy42NUw3IDE3LjY1QzYuNjQxMDEgMTcuNjUgNi4zNSAxNy4zNTkgNi4zNSAxN0M2LjM1IDE2LjY0MSA2LjY0MTAxIDE2LjM1IDcgMTYuMzVMMTUuNDMwOCAxNi4zNUw2LjU0MDM4IDcuNDU5NjNDNi4yODY1NCA3LjIwNTc4IDYuMjg2NTQgNi43OTQyMyA2LjU0MDM4IDYuNTQwMzlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";